import arrayMutators from "final-form-arrays";
import { cloneDeep, flatMap } from "lodash-es";
import React, { useMemo, useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { formatDateTime } from "../../../util/formatters";
import { snakifyKeys } from "../../../util/helpers";
import { XifinAuthConfigForm } from "./XifinAuthConfigForm";

export const EditXifinAuthConfigModal = ({ xifinConfig, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleUpdate = async (values) => {
    const newValues = cloneDeep(values);

    const { xifinConfig } = values;
    const formIds = flatMap(xifinConfig, "id");
    setError(null);

    try {
      /** Form the payload */
      const params = {
        xifinAuthNumberOverrides: {
          ...newValues,
        },
      };

      /** Fire the request */
      const res = await api.patch(`/admin/xifin_auth_number_overrides/${newValues.id}`, snakifyKeys(params));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };
  /** where we will set the initial values */
  const initialValues = useMemo(
    () => ({
      ...xifinConfig,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(xifinConfig)]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Edit Xifin Auth Config</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <dl>
            <dt>Created At</dt>
            <dd>{formatDateTime(xifinConfig.createdAt)}</dd>

            <dt>Last Updated At</dt>
            <dd>{formatDateTime(xifinConfig.updatedAt)}</dd>
          </dl>

          <Form onSubmit={handleUpdate} mutators={{ ...arrayMutators }} initialValues={initialValues}>
            {(props) => <XifinAuthConfigForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
